import { Grid, Box } from "@mui/material";
import PageButton from "../../components/PageButton";
import PageTypography from "../../components/PageTypography/PageTypography";

export interface PageHeaderProps {
  title: string;
  subtitle?: string;
  buttonLabel?: string;
  onButtonClick?: () => void;
  startIcon?: React.ReactNode;
  children?: React.ReactNode; // 👈 NEW
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  buttonLabel,
  startIcon,
  onButtonClick,
  children,
}) => {
  return (
    <Grid container alignItems="center" justifyContent="space-between" spacing={2}>
      
      {/* LEFT CONTENT */}
      <Grid item>
        <Box>
          <PageTypography variant="h4" fontWeight="bold">
            {title.toUpperCase()}
          </PageTypography>

          {subtitle && (
            <PageTypography variant="subtitle2" color="text.secondary">
              {subtitle}
            </PageTypography>
          )}
        </Box>
      </Grid>

      {/* RIGHT CONTENT */}
      <Grid item>
        <Box display="flex" alignItems="center" gap={2}>
          {children} {/* 👈 Any extra content */}
          
          {buttonLabel && (
            <PageButton
              variant="contained"
              onClick={onButtonClick}
              startIcon={startIcon}
            >
              {buttonLabel}
            </PageButton>
          )}
        </Box>
      </Grid>

    </Grid>
  );
};

export default PageHeader;
